<style lang="sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import ../../assets/sass/m3_variables
@import sass/referencesDetails
</style>

<template>
    <Zone
        :id="data.id"
        :dataLabel="data.dataLabel"
        :contrast="contrast"
        class="g_referencesDetails"
        autoHeight>
        <Heading
            :level="heading"
            v-html="data.title" />
        <ul>
            <li v-for="(item, index) of data.list" :key="index">
                <Heading
                    :level="3"
                    v-html="item.title"/>
                <Paragraph
                    :content="item.location"
                    size="M" />
            </li>
        </ul>
    </Zone>
</template>

<script>
export default {
    name: 'ReferencesDetails',
    props: {
        data: {
            type: Object,
            required: true
        },
        contrast: {
            type: String,
            default: 'dark'
        },
        heading: {
            type: Number,
            default: 2
        }
    }
}
</script>
